export default "__VITE_ASSET__DdPA55Qh__"